<template>
  <div>
    <b-card>
      <h5>{{ $t('main_contact_person') }}</h5>
      <b-card>
        <validation-observer
          ref="companyRegisterValidation"
          name="RegisterCompany"
        >
          <b-row
            m-0
            p-0
          >
            <b-col
              cols="12"
              xl="6"
              md="6"
              lg="6"
            >

              <b-form-group
                id="main-contact-gender"
                :label="$t('salutation') + ':'"
                label-for="main-contact-gender"
              >
                <validation-provider
                  #default="{ errors }"
                  name="main-contact-gender"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                  >
                    <b-input-group-prepend
                      is-text
                      :class="
                        main_contact_gender.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                    >
                      <feather-icon
                        icon="UserIcon"
                        class="cursor-pointer"
                      />
                    </b-input-group-prepend>
                    <b-form-select
                      id="main-contact-gender"
                      v-model.trim="main_contact_gender"
                      :disabled="isCompleted"
                      :class="
                        main_contact_gender.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                      :options="[
                        {
                          text: $t('select_one'),
                          value: null,
                          disabled: true,
                        },
                        { text: $t('mr'), value: '0' },
                        { text: $t('mrs'), value: '1' },
                      ]"
                      required
                      :state="errors.length > 0 ? false : null"
                    />
                  </b-input-group>
                </validation-provider>
                <small class="text-danger">{{ $t(main_contact_gender_error) }}</small>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              xl="6"
              md="6"
              lg="6"
            >
              <b-form-group
                id="main-contact-email-group"
                :label="$t('company_email_address') + ':'"
                label-for="main-contact-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Number of Debtors"
                  rules="required|email"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend
                      is-text
                      :class="
                        main_contact_email.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                    >
                      <feather-icon
                        icon="MailIcon"
                        class="cursor-pointer"
                      />
                    </b-input-group-prepend>
                    <b-form-input
                      id="main-contact-email"
                      v-model.trim="main_contact_email"
                      :class="
                        main_contact_email.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                      required
                      :disabled="isCompleted"
                      :state="errors.length > 0 ? false : null"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            m-0
            p-0
          >
            <b-col
              cols="12"
              xl="6"
              md="6"
              lg="6"
            >
              <b-form-group
                id="main-contact-first-name-group"
                :label="$t('first_name') + ':'"
                label-for="main-contact-first-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="First name"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend
                      is-text
                      :class="
                        main_contact_first_name.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                    >
                      <feather-icon
                        icon="UserIcon"
                        class="cursor-pointer"
                      />
                    </b-input-group-prepend>
                    <b-form-input
                      id="main-contact-first-name"
                      v-model.trim="main_contact_first_name"
                      required
                      :class="
                        main_contact_first_name.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                      :state="errors.length > 0 ? false : null"
                      :disabled="isCompleted"
                    />
                  </b-input-group>

                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              xl="6"
              md="6"
              lg="6"
            >
              <b-form-group
                id="main-contact-tel-group"
                :label="$t('mobile') + ':'"
                label-for="main-contact-tel"
              >
                <validation-provider
                  ref="phoneValidator"
                  #default="{ errors }"
                  name="phoneValidation"
                  rules="required"
                >
                  <b-input-group>
                    <b-input-group-prepend
                      id="phoneCountries"
                      :class="
                        main_contact_tel.length > 0
                          ? 'phoneCountries '
                          : showBlueBorder
                            ? 'phoneCountries is-empty'
                            : 'phoneCountries'
                      "
                    >
                      <b-form-select
                        v-model.trim="phoneContries"
                        :disabled="isCompleted"
                        :options="countries"
                      />
                    </b-input-group-prepend>
                    <b-form-input
                      id="main-contact-tel"
                      v-model.trim="main_contact_tel"
                      class="form-control"
                      :state="errors.length > 0 ? false : null"
                      :disabled="isCompleted"
                      :class="
                        main_contact_tel.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                      @input="checkPhoneFormat"
                    />
                  </b-input-group>

                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                  <small
                    v-if="phoneValidation"
                    class="text-danger is-invalid"
                  >{{ phoneValidation }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            m-0
            p-0
          >
            <b-col
              cols="12"
              xl="6"
              md="6"
              lg="6"
            >
              <b-form-group
                id="main-contact-last-name-group"
                :label="$t('last_name') + ':'"
                label-for="main-contact-last-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Last Name"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend
                      is-text
                      :class="
                        main_contact_last_name.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                    >
                      <feather-icon
                        icon="UserIcon"
                        class="cursor-pointer"
                      />
                    </b-input-group-prepend>
                    <b-form-input
                      id="main-contact-last-name"
                      v-model.trim="main_contact_last_name"
                      :class="
                        main_contact_last_name.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                      required
                      :state="errors.length > 0 ? false : null"
                      :disabled="isCompleted"
                    />
                  </b-input-group>

                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              xl="6"
              md="6"
              lg="6"
            >
              <b-form-group
                id="main-contact-position-group"
                :label="$t('position_in_the_company') + ':'"
                label-for="main-contact-position"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Position in the Company"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend
                      is-text
                      :class="
                        main_contact_position.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                    >
                      <feather-icon
                        icon="BriefcaseIcon"
                        class="cursor-pointer"
                      />
                    </b-input-group-prepend>
                    <b-form-input
                      id="main-contact-position"
                      v-model.trim="main_contact_position"
                      :class="
                        main_contact_position.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                      required
                      :state="errors.length > 0 ? false : null"
                      :disabled="isCompleted"
                    />
                  </b-input-group>

                </validation-provider>
                <small class="text-danger">{{ $t(main_contact_position_error) }}</small>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            m-0
            p-0
          >
            <b-col
              cols="12"
              xl="12"
              md="12"
              lg="12"
            >
              <b-form-group
                id="signing-authority-type-group"
                :label="$t('signatory_rights') + ':'"
                label-for="signing-authority-type"
                rules="required"
              >
                <validation-provider
                  #default="{ errors }"
                  name="signing-authority-type-group"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend
                      is-text
                      :class="
                        signing_authority_type.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                    >
                      <feather-icon
                        icon="UserPlusIcon"
                        class="cursor-pointer"
                      />
                    </b-input-group-prepend>
                    <b-form-select
                      id="signing-authority-type"
                      v-model.trim="signing_authority_type"
                      :disabled="isCompleted"
                      :class="
                        signing_authority_type.length > 0
                          ? ''
                          : showBlueBorder
                            ? 'is-empty'
                            : ''
                      "
                      :options="[
                        {
                          text: $t('select_one'),
                          value: '',
                          disabled: true,
                        },
                        { text: $t('no_signatory'), value: '2' },
                        { text: $t('sole_signatory'), value: '0' },
                        { text: $t('collectively_by_two'), value: '1' },

                      ]"
                      required
                      :state="errors.length > 0 ? false : null"
                    />
                  </b-input-group>
                </validation-provider>
                <small class="text-danger">{{ signing_authority_type_error }}</small>
              </b-form-group>
            </b-col>
            <b-col
              v-if="signing_authority_type == 2"
              cols="12"
              xl="12"
              md="12"
              lg="12"
            >
              <b-form-group
                id="signing-authority-type-group"
                :label="$t('how_many_signatures') + ':'"
                label-for="signing-authority-type"
                rules="required"
              >
                <b-form-select
                  v-model.trim="choose_signing_authority_type"
                  :disabled="isCompleted"
                  :options="[
                    {
                      text: $t('select_one'),
                      value: null,
                      disabled: true,
                    },
                    {text: $t('one_signatory'), value: '1'},
                    {text: $t('two_signatories'), value: '2'},
                  ]"
                />
                <small class="text-danger">{{ choose_signing_authority_type_error }}</small>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="my-5">
            <b-col
              v-if="signing_authority_type == 2"
              cols="12"
            >
              <template v-if="choose_signing_authority_type == 1">
                <!--No Signatory one signatories-->
                <skribble-power-of-attorney-one-signatory @save-requested="saveData($event)" @internal-save="saveInternalData($event)"></skribble-power-of-attorney-one-signatory>
              </template>
              <template v-if="choose_signing_authority_type == 2">
                <!--No Signatory two signatories-->
                <skribble-power-of-attorney-two-signatories @save-requested="saveData($event)" @internal-save="saveInternalData($event)"></skribble-power-of-attorney-two-signatories>
              </template>
            </b-col>
            <b-col v-if="signing_authority_type == 1">
              <!--Collectively By Two-->
              <skribble-power-of-attorney-collectively-by-two @save-requested="saveData($event)" @internal-save="saveInternalData($event)"></skribble-power-of-attorney-collectively-by-two>
            </b-col>
          </b-row>
        </validation-observer>
      </b-card>
      <b-row m-0 p-0 class="col-12 text-end justify-content-between" align="end">
        <div col="6">
          <b-link class="btn btn-outline-primary ml-1" to="/"> <FeatherIcon icon="ChevronLeftIcon"></FeatherIcon> {{ $t("back_to_dashboard") }} </b-link>
        </div>
        <div col="6">
          <div class="text-right">
            <img v-if="resLoader" width="50" height="50" src="/new-loader.svg"/>

            <b-button
              v-if="signing_authority_type == 0"
              variant="primary"
              @click="saveData($event)"
            >
              <feather-icon icon="SaveIcon" />
              {{ $t('continue') }}
            </b-button>
          </div>
        </div>
      </b-row>
    </b-card>

  </div>
</template>

<script>

import {
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import { phone } from 'phone'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SkribblePowerOfAttorneyOneSignatory from "@/components/skribble/PowerOfAttorneyOneSignatory.vue";
import SkribblePowerOfAttorneyTwoSignatories from "@/components/skribble/PowerOfAttorneyTwoSignatories.vue";
import SkribblePowerOfAttorneyCollectivelyByTwo from "@/components/skribble/PowerOfAttorneyCollectivelyByTwo.vue";

export default {
  name: 'SigningAuthority',
  components: {
    BFormInput,
    BInputGroupPrepend,
    BCard,
    BFormSelect,
    BFormGroup,
    BInputGroup,
    BButton,
    ValidationProvider,
    BCol,
    BRow,
    SkribblePowerOfAttorneyOneSignatory,
    SkribblePowerOfAttorneyTwoSignatories,
    SkribblePowerOfAttorneyCollectivelyByTwo,
  },
  data() {
    return {
      isCompleted: false,
      signators: [],
      showBlueBorder: true,
      disableInputs: false,
      countries: [],

      main_contact_gender: '',
      main_contact_gender_error: '',
      main_contact_email: this.$store.state.auth.user.email,
      main_contact_first_name: this.$store.state.auth.user.first_name,
      main_contact_last_name: this.$store.state.auth.user.last_name,
      main_contact_tel: '',
      main_contact_position: '',
      main_contact_position_error: '',

      phoneContries: 'CH',
      phoneValidation: '',

      signing_authority_type: '',
      signing_authority_type_values: ['Sole signatory', 'Collectively by two'],
      choose_signing_authority_type: null,
      phoneSignatorValidation: '',
      emailValidationsError: '',
      resLoader: false,

      signing_authority_type_error: null,
      choose_signing_authority_type_error: null,
      showButton:false,

      skribbleSigningUrl: null,
      prefillDataArray: {
        Dropdown1: null,
        Dropdown4: null,
        Name3_First: null,
        Name3_Last: null,
        Address1_AddressLine1: null,
        Address1_City: null,
        Address1_ZipCode: null,
        Address1_Country: null,
        Email: null,
        SingleLine: null,
        Address_AddressLine1: null,
        Address_ZipCode: null,
        Address_City: null,
        Address_Country: null,
      },
    }
  },

  created() {
    this.prefillData();
    this.language = this.$i18n.locale
    this.getData()
    this.$http.post('/countries').then(res => {
      res.data.value.map(item => {
        this.countries.push({
          value: item.iso_code,
          text: `${item.iso_code} (${item.phone_code})`,
        })
      })
    })
  },

  methods: {
    prefillData() {
      this.$http.post(`/company/get-user-company`).then(res => {
        const user = res.data.value
        this.prefillDataArray.Dropdown1 = user.gender == '1' ? 'Ms.' : 'Mr.';
        this.prefillDataArray.Dropdown4 = user.gender == '1' ? 'Frau' : 'Herr';
        this.prefillDataArray.Name3_First = user.name;
        this.prefillDataArray.Name3_Last = user.last_name;
        this.prefillDataArray.Address1_AddressLine1 = user.address ?? '';
        this.prefillDataArray.Address1_City = user.city ?? '';
        this.prefillDataArray.Address1_ZipCode = user.zip ?? '';
        this.prefillDataArray.Address1_Country = user.country?.name ?? '';
        this.prefillDataArray.Email = user.email;
        this.prefillDataArray.SingleLine = user.company?.name ?? '';
        this.prefillDataArray.Address_AddressLine1 = user.company?.address ?? '';
        this.prefillDataArray.Address_ZipCode = user.company?.zip ?? '';
        this.prefillDataArray.Address_City = user.company?.city ?? '';
        this.prefillDataArray.Address_Country = user.company?.country?.name ?? '';
      });
    },
    getData() {
      this.$http.post(`/company/get-main-contact/${this.$store.state.auth.user.id}`).then(res => {
        if (res) {
          if (res.data.status == 200) {
            const data = res.data.value

            this.main_contact_first_name = data.name,
            this.main_contact_last_name = data.last_name,
            this.main_contact_gender = String(data.gender)
            this.main_contact_position = data.position
            this.main_contact_tel = data.tel
            this.signing_authority_type = data.signing_authority_type
            this.choose_signing_authority_type = data.signing_authority_type_count
            this.phoneContries = data.iso_code
            this.isCompleted = data.is_completed

            if (this.signing_authority_type != 2) {
              this.choose_signing_authority_type = null
            }
          }
        }
      })
    },

    deleteSignator(index) {
      this.signators.splice(index, 1)
    },

    checkPhoneFormat() {
      const validation = phone(this.main_contact_tel, {
        country: this.phoneContries,
        validateMobilePrefix: false,
      })

      if (validation && validation.isValid == false) {
        this.phoneValidation = `Phone for ${this.phoneContries} must be valid`
      } else {
        this.phoneValidation = ''
      }
    },

    async saveData() {
      try {
        this.resLoader = true

        let customValidate = true

        if (!this.signing_authority_type || this.signing_authority_type === '') {
          this.signing_authority_type_error = 'Signatory rights field is required'
          customValidate = false
        }

        if (this.signing_authority_type === '2' && !this.choose_signing_authority_type) {
          this.choose_signing_authority_type_error = 'Select how many signatures'
          customValidate = false
        }

        if (!this.main_contact_gender) {
          this.main_contact_gender_error = 'The Salutation field is required'
          customValidate = false
        }

        if (!this.main_contact_position) {
          this.main_contact_position_error = 'The Position in the company field is required'
          customValidate = false
        }

        if(!customValidate || this.phoneValidation.length > 0 || this.emailValidationsError.length > 0) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return
        }


        if (
          this.phoneValidation.length < 1
          && this.emailValidationsError.length < 1
        ) {
          this.disableInputs = true

          const formSubmissionData = {
            main_contact_id: this.$store.state.auth.user.id,
            main_contact_first_name: this.main_contact_first_name,
            main_contact_last_name: this.main_contact_last_name,
            main_contact_gender: parseInt(this.main_contact_gender),
            main_contact_position: this.main_contact_position,
            main_contact_tel: this.main_contact_tel,
            main_contact_iso_code: this.phoneContries,
            main_contact_signing_authority_type: this.signing_authority_type,
            main_contact_signing_authority_type_count: this.choose_signing_authority_type,
          }

          const res = await this.$http.post('/company/store-main-contact', formSubmissionData)

          if (res && res.data.status == 200) {
            this.$router.push('/')
          }
        }
      } catch (error) {
        console.error('Error:', error)
        this.resLoader = false
      } finally {
        this.resLoader = false
      }
    },

    async saveInternalData() {
      try {
        this.resLoader = true

        let customValidate = true

        if (!this.signing_authority_type || this.signing_authority_type === '') {
          this.signing_authority_type_error = 'Signatory rights field is required'
          customValidate = false
        }

        if (this.signing_authority_type === '2' && !this.choose_signing_authority_type) {
          this.choose_signing_authority_type_error = 'Select how many signatures'
          customValidate = false
        }

        if (!this.main_contact_gender) {
          this.main_contact_gender_error = 'The Salutation field is required'
          customValidate = false
        }

        if(!customValidate || this.phoneValidation.length > 0 || this.emailValidationsError.length > 0) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return
        }

        if (this.phoneValidation.length < 1 && this.emailValidationsError.length < 1 ) {
          this.disableInputs = true

          const formSubmissionData = {
            main_contact_id: this.$store.state.auth.user.id,
            main_contact_first_name: this.main_contact_first_name,
            main_contact_last_name: this.main_contact_last_name,
            main_contact_gender: parseInt(this.main_contact_gender),
            main_contact_position: this.main_contact_position ?? '',
            main_contact_tel: this.main_contact_tel,
            main_contact_iso_code: this.phoneContries,
            main_contact_signing_authority_type: this.signing_authority_type,
            main_contact_signing_authority_type_count: this.choose_signing_authority_type,
          }

         await this.$http.post('/company/store-main-contact', formSubmissionData)

        }
      } catch (error) {
        console.error('Error:', error)
        this.resLoader = false
      } finally {
        this.resLoader = false
      }
    },

  },

}

</script>

<style scoped>
  .checkbox-error >>> .custom-control-label::before {
    border-color: red !important;
    background-color: transparent !important;
  }
</style>
